import React from 'react';
import { Reservation } from '../types/hospitable';
import { Calendar, User, Home, DollarSign } from 'lucide-react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import BulkInvoiceGenerator from './BulkInvoiceGenerator';

interface ReservationListProps {
  reservations: Reservation[];
  companyInfo?: any;
}

const ReservationList: React.FC<ReservationListProps> = ({
  reservations,
  companyInfo,
}) => {
  // Trier les réservations par date de check-in en ordre descendant (plus récente en premier)
  const sortedReservations = [...reservations].sort((a, b) => {
    return new Date(b.check_in).getTime() - new Date(a.check_in).getTime();
  });

  return (
    <div className="reservation-list">
      <h2>Réservations</h2>
      {sortedReservations.length === 0 ? (
        <p className="no-data">Aucune réservation trouvée</p>
      ) : (
        <div className="reservations-grid">
          {sortedReservations.map((reservation) => (
            <div
              key={reservation.id}
              className="reservation-card"
            >
              <div className="reservation-header">
                <span className="reservation-id">#{reservation.confirmation_code || reservation.id}</span>
              </div>
              
              <div className="reservation-body">
                <div className="info-row">
                  <User size={16} />
                  <span>{reservation.guest_name}</span>
                </div>
                
                <div className="info-row">
                  <Home size={16} />
                  <span>{reservation.property_name}</span>
                </div>
                
                <div className="info-row">
                  <Calendar size={16} />
                  <span>
                    {format(new Date(reservation.check_in), 'dd MMM', { locale: fr })} - 
                    {format(new Date(reservation.check_out), 'dd MMM yyyy', { locale: fr })}
                  </span>
                </div>
                
                <div className="info-row">
                  <DollarSign size={16} />
                  <span className="amount">{reservation.total_amount.toFixed(2)} €</span>
                </div>
              </div>
              
              <div className="reservation-footer">
                <span className={`status ${reservation.status.toLowerCase()}`}>
                  {reservation.status}
                </span>
                <span className="nights">{reservation.nights} nuits</span>
              </div>
              
              {companyInfo && reservation.total_amount > 0 && (
                <div style={{ marginTop: '15px', paddingTop: '15px', borderTop: '1px solid #e0e0e0' }}>
                  <BulkInvoiceGenerator 
                    reservation={reservation} 
                    companyInfo={companyInfo}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReservationList;